import { Box, Divider, Typography } from '@mui/material';
import { formatDateWhitoutHour } from '../../services/helpers/helpers';
import { useEffect, useState } from 'react';
import { DamsServices } from '../../services/api/dams/DamServices';
import { NotificacaoService } from '../../services/api/notificacao/NotificacaoService';
import NotificationTable from './NotificationTable';

interface TableForecastProps {
	uuid_dam: string,
	onRefreshNeeded?: () => void;
}

export default function TableForecast({ uuid_dam, onRefreshNeeded }: TableForecastProps) {

	const [data, setData] = useState<any | null>(null);
	const [dataNotifications, setDataNotifications] = useState<any | null>(null);

	useEffect(() => {
		getData(uuid_dam);
		getDataNotifications(uuid_dam);
	}, []);

	useEffect(() => {
		getDataNotifications(uuid_dam);
	}, [onRefreshNeeded]);

	async function getData(uuid_dam: string) {
		try {
			const response = await DamsServices.getForecast(uuid_dam);
			const previsao = JSON.parse(response.previsao);
			setData(previsao.timelines.daily);
		} catch (error) {
			console.log(error);
		}
	}

	async function getDataNotifications(uuid_dam: string) {
		try {
			const response = await NotificacaoService.getNotifications(uuid_dam);

			if (response && Array.isArray(response.data)) {
				setDataNotifications(response.data);
			} else {
				setDataNotifications([]);
			}

		} catch (error) {
			console.log('Erro ao buscar notificações:', error);
			setDataNotifications([]);
		}
	}

	const handleNotificationDeleted = () => {
		getDataNotifications(uuid_dam);
	};

	console.log(dataNotifications);
	return (
		<Box>
			<Box height={'auto'} width={'100%'} sx={{ display: 'flex', flexDirection: 'row', gap: '1rem', overflowX: 'auto', paddingY: '1rem' }}>
				{data !== null && (
					data.map((dia: any) => (
						<Box key={dia.time} height={'11rem'} minWidth={'10rem'} border={1} sx={{ padding: '1rem', display: 'flex', flexDirection: 'column', gap: '0.5rem', borderRadius: '25px', boxShadow: 'initial' }}>
							<Typography textAlign={'center'}>{formatDateWhitoutHour(dia.time)}</Typography>
							<Divider />
							<Typography textAlign={'center'}>Temp: {dia.values.temperatureMin + '°c'} / {dia.values.temperatureMax + '°c'}</Typography>
							<Typography textAlign={'center'}>Umidade: {dia.values.humidityMin + '%'} / {dia.values.humidityMax + '%'}</Typography>
							<Typography textAlign={'center'}>Precipitação: {dia.values.precipitationSum + 'mm'}</Typography>
							<Typography textAlign={'center'}>Vento Máx: {dia.values.windSpeedMax + 'km/h'}</Typography>
						</Box>
					))
				)}
			</Box>

			<Divider />
			<Box sx={{ paddingY: '1rem' }}>
				<Typography variant="h5" gutterBottom>
					Notificações Configuradas
				</Typography>
				<NotificationTable
					notifications={dataNotifications}
					onDeleteSuccess={handleNotificationDeleted} 
				/>
			</Box>
		</Box>
	);
}